import React from "react";
import GenericOrdersListing from "@Pages/OrderListing/GenericOrdersListing.js";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import ChatPopup from "@Pages/GenericOrderChat/ChatPopup.jsx";
function PlanningManagerStarredOrdersListing() {
  return (
    <GenericOrdersListing
      title="Starred Orders"
      isReleased={false}
      isCanceled={false}
      readOnly={true}
      icon={AssignmentRoundedIcon}
      ChatPopup={ChatPopup}
      showAddOrder={false}
      isStarred={true}
    />
  );
}

export default PlanningManagerStarredOrdersListing;
